<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="10" cy="10" r="10" fill="currentColor"/>
  <rect x="9.166" y="5" width="1.667" height="6.25" rx="0.833" fill="white"/>
  <circle cx="10" cy="14.166" r="0.917" fill="white"/>
</svg>
